import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ErrCode, ErrorMessages, User } from '../../models';
import { DomSanitizer } from '@angular/platform-browser';
import { Button } from '@material-library';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorComponent {
  public _errCode: ErrCode;
  @Input() public overrideErrorMsgWithServer = false;

  @Input() public set errcode(errcode: ErrCode) {
    this._errCode = { ...errcode };
    if (errcode && errcode.code) {
      // Error message should always pick from error code mapping in error-messages.model.ts.
      // When error message not found in error-messages.model.ts, Then it will by default pick errorcode.msg or 'An error occurred.'
      if (ErrorMessages[errcode.code] && !errcode.isCustomMsg) {
        if (!this.overrideErrorMsgWithServer) {
          this._errCode.msg = ErrorMessages[errcode.code];
        }
      }
    }
  }

  @Input() public showErrCode?: boolean = true;

  private _primaryButtonConfig?: Button;
  public showActions = false;
  @Input() public set primaryButtonConfig(primaryButtonConfig: Button) {
    if (primaryButtonConfig) {
      this._primaryButtonConfig = primaryButtonConfig;
      this.showActions = true;
    }
  }
  public get primaryButtonConfig(): Button {
    return this._primaryButtonConfig;
  }

  public user: User;

  constructor(private sanitizer: DomSanitizer) {}
}
